<div class="grid-location-wrapper">
  <div class="header-container">
    <div class="header-main-view">

      <div class="logo-container notch-safe-area">
        <ng-container *ngIf="whitelabel$ | async as whitelabel">
          <img class="logo" [src]="getLogo(whitelabel)" alt="white label"/>
        </ng-container>
      </div>
      <!-- Header -->     

      <div class="header">
        <!-- {{ 'loc-heading' | translate *ngIf="seletedLocatioId"
        }} -->
        <img
          *ngIf="seletedLocatioId"
          [src]="closeIcon"
          (click)="closeOrganizationLocation()"
          data-qa="close-button"
          class="close"
          aria-label="close"
          alt="close"
        />
      </div>
  
      <div class="header-section" *ngIf="!allowOnlyGuestUsers">
        
        <ng-container *ngIf="
        loggedInUserDetails$ | async as loggedInUserDetails;
        else guest_user
      ">
      <div>
            <moduurnv2-button-drop-down  *ngIf="
            loggedInUserDetails && loggedInUserDetails.isLoggedIn;
            else guest_user
          "        
            [letterForImage]="
              loggedInUserDetails.userName
                ? loggedInUserDetails.userName.charAt(0)
                : ''
            "
            [buttonText]="loggedInUserDetails.userName"
            [items]="userMenuItems"
            (selectedItem)="getSeletedMenu($event)"
          ></moduurnv2-button-drop-down>
          <!-- <ordering-app-header-desktop></ordering-app-header-desktop> -->
        </div>
        </ng-container>
        <ng-template #guest_user
          ><button (click)="showRegister()" data-qa="login-register-button" class="login-register">
            {{ 'Login_Register' | translate }}
          </button></ng-template
        >        
      </div>

    </div>
   

    <div [ngClass]="{'location-desktop-container': !isMobileView}">
      <div class="tab-buttons" *ngIf = "yepDeskEvents || favouriteLocationView">
        <div class="tab-button">
          <input
            type="radio"
            name="tabSection"
            [checked]="getSelectedTab('LOCATION')"
            (click)="tabClick('LOCATION')"
            
          />
          <div class="radio-container">
            Locations
          </div>
        </div>
        <div class="tab-button" *ngIf = "yepDeskEvents">
          <input
            type="radio"
            name="tabSection"
            (click)="selectevent()"
          />
          <div class="radio-container" >
            Events
          </div>
        </div>
        <div class="tab-button" *ngIf = "favouriteLocationView">
          <input
            type="radio"
            name="tabSection"
            [checked]="getSelectedTab('FAVORITE')"
            (click)="tabClick('FAVORITE')"
          />
          <div class="radio-container" >
            Your Favourites
          </div>
        </div>
      </div>
      <!-- Search bar -->
      <div class="search-bar" *ngIf="locationview">
        <!-- <input
        data-qa="search-input"
        type="text"
        placeholder="{{ 'loc-search-placeholder' | translate }}"
      /><img class="location-map-icon" [src]="locationPinIcon" alt="map"/> -->
      <div class="location-map-icon">
        <img class="search-icon" src="/assets/images/search-icon.svg" alt="search"/>
      </div>
        <!-- <div id="geocoder"></div> -->
        <input type="text" [(ngModel)]="locationSearchQuery" placeholder="{{ locationSearchPlaceholder | translate }}" (keyup)="filterLocationByQuery()">
        <img [src]="searchClose" *ngIf="locationSearchQuery" (click)="clearlocationSearch()" alt="search">
      </div>

      <div class="header secondary-header" *ngIf="isRestaurantsAvailable && locationview">
          {{ 'choose-store' | translate}}
      </div>
    </div>
    <!-- <div class="header secondary-header" *ngIf="!locationview">
      Display Our Events 
  </div> -->
    
     <!-- <div class="tab-buttons">
      <div class="tab-button">
        <input
          type="radio"
          name="tabSection"
          checked
          (click)="tabClick()"
          data-qa="location-all-button"
        />
        <div class="radio-container">
          {{ 'loc-tab-1' | translate }}
        </div>
      </div>
      <div class="tab-button">
        <input
          type="radio"
          name="tabSection"
          (click)="tabClick('FAVORITE')"
          data-qa="location-favourite-button"
          disabled
        />
      </div>
    </div> -->
    
  </div>
  <div *ngIf=" locationview == false">
    <div class="eventarea">
      <yepdesk-events-mobile></yepdesk-events-mobile>
    </div>
  </div>

  <!-- Locations list -->
  <div *ngIf="isRestaurantsAvailable && locationview == true" class="outer-panel custom-scroll scroll-small">
    <div
      class="location-cards" [ngClass]="{'location-desktop-container': !isMobileView}"
      [ngStyle]="{'margin-top': yepDeskEvents || favouriteLocationView ? 'calc( 15rem + env(safe-area-inset-top))' :  'calc( 12rem + env(safe-area-inset-top))'}"
      [class.eventsincludedcontainer] = "yepDeskEvents"
    >
      <ng-container
        *ngIf="
          organizationLocations && organizationLocations.length > 0;
          else locationsLoading
        "
      >
        <ng-container
          *ngFor="let location of organizationLocations; trackBy: trackById"
        >
          <moduurnv2-location
            [location]="location"
            [isLocationOn]="isLocationOn"
            class="location"
            [showLocationImage]="showLocationImage"
          ></moduurnv2-location>
        </ng-container>
      </ng-container>
      <ng-template #locationsLoading>
          <div class="content-loader" *ngFor="let i of skeletalCounter(6)">
              <div class="option-item">
                <div class="option-heading loader"></div>
                <div class="content-item loader"></div>
                <div class="content-item loader"></div>
                <div class="content-item loader"></div>
                <div class="content-item loader"></div>
                <div class="content-item loader"></div>
                <div class="content-item content-half loader"></div>
                <div class="content-item content-half loader"></div>
              </div>
          </div>
      </ng-template>
  
    </div>

  </div>





  <div class="no-data location-cards" *ngIf="!isRestaurantsAvailable">
    {{ 'no-resturants' | translate }}
  </div>
</div>



